.antCard {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}
